"use client";

import styles from "@/styles/global/float-menu.module.scss";
import Image from "next/image";
import Link from "next/link";
import { useAppDispatch } from '@/store/hooks';
import { openCategoryPopup } from '@/store/slices/modalSlice';
import { useState, useEffect } from 'react';
import { usePathname } from 'next/navigation';

export default function FloatMenu() {
  const pathname = usePathname();
  const showFloatMenu = pathname !== '/checkout' && pathname !== '/view-cart';

  const dispatch = useAppDispatch();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      if (scrollPosition > 400) {
        setVisible(true);
      } else {
        setVisible(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll(); // 初始检查

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <div 
      className={styles["comp-float-menu"]} 
      style={{ display: visible && showFloatMenu ? 'block' : 'none' }}
    >
      <Link href={'/contact'}>
        <Image
          className={styles['float-icon']}
          src={`${process.env.IMAGE_DOMAIN}/svg/float-phone.svg`}
          alt={'float-phone'}
          width={40}
          height={40}
        ></Image>
      </Link>
      
      <Image
        className={styles['float-icon']}
        src={`${process.env.IMAGE_DOMAIN}/svg/float-menu.svg`}
        alt={'float-phone'}
        width={40}
        height={40}
        onClick={() => dispatch(openCategoryPopup())}
      ></Image>
      
      <Image
        className={styles['float-icon']}
        src={`${process.env.IMAGE_DOMAIN}/svg/float-top.svg`}
        alt={'float-top'}
        width={40}
        height={40}
        onClick={scrollToTop}
      ></Image>
    </div>
  );
}